module.exports = __webpack_public_path__ + "static/media/relay-app-min.186a3816.png";